import React from 'react';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import TulipIcon from '../../assets/tulip.svg';
import DemoCard from '../../assets/demo-card.svg';
import DefaultCard from './DefaultCard';
import Label from '../Label';
import Button from '../Button';

const DefaultCardDemo = () => {
  return (
    <Container>
      <Container className="mt-10 pb-10 pt-10">
        <Row>
          <h4>Extra Small Default Cards</h4>
          <Col className="mt-10 pl-10 col-3">
            <DefaultCard
              className="hi"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              rightHeading="Lorem Ipsum"
              rightSubheading="Lorem Ipsum"
              button={
                <Button variant="primary-outline" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-3">
            <DefaultCard
              variant="white"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              overlineLabel={
                <Label leftIcon={light('circle-exclamation')}>
                  Lorem Ipsum
                </Label>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-3">
            <DefaultCard
              variant="blue"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna."
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-3">
            <DefaultCard
              variant="blue-motif"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis."
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
        </Row>
        <Row className="mt-10">
          <h4>Small Default Cards</h4>
          <Col className="mt-10 pl-10 col-4">
            <DefaultCard
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              rightHeading="Lorem Ipsum"
              rightSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              button={
                <Button variant="primary-outline" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-4">
            <DefaultCard
              variant="white"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem."
              overlineLabel={
                <Label leftIcon={light('circle-exclamation')}>
                  Lorem Ipsum
                </Label>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-4">
            <DefaultCard
              variant="blue"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-4">
            <DefaultCard
              variant="blue-motif"
              leftHeading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo."
              leftSubheading="Lorem Ipsum"
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
        </Row>
        <Row className="mt-10">
          <h4>Normal Default Cards</h4>
          <Col className="mt-10 pl-10 col-6">
            <DefaultCard
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              rightHeading="Lorem Ipsum"
              rightSubheading="Lorem Ipsum"
              button={
                <Button variant="primary-outline" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-6">
            <DefaultCard
              variant="white"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              overlineLabel={
                <Label leftIcon={light('circle-exclamation')}>
                  Lorem Ipsum
                </Label>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-6">
            <DefaultCard
              variant="blue"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-6">
            <DefaultCard
              variant="blue-motif"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem Ipsum"
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
        </Row>
        <Row className="mt-10">
          <h4>Large Default Cards</h4>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              rightHeading="Lorem Ipsum"
              rightSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              button={
                <Button variant="primary-outline" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              variant="white"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              overlineLabel={
                <Label leftIcon={light('circle-exclamation')}>
                  Lorem Ipsum
                </Label>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              variant="blue"
              leftHeading="Lorem Ipsum"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              variant="blue-motif"
              leftHeading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              leftSubheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
        </Row>
        <Row className="mt-10">
          <h4>Large Default Cards, with complex subheadings</h4>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              leftHeading="Lorem Ipsum"
              leftSubheading={
                <div>
                  <b>
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit.&nbsp;
                  </b>
                  <i>
                    Aliquam auctor massa eu quam venenatis tincidunt. Nunc a
                    mollis urna, sit amet placerat leo. Vivamus non rutrum urna.
                    Proin hendrerit erat in dolor hendrerit euismod.&nbsp;
                  </i>
                  <u>
                    Mauris elitnibh, congue vel augue sit amet, dignissim
                    consequat turpis.&nbsp;
                  </u>
                  Curabitur scelerisque, est tristique ultricies cursus, mi enim
                  suscipit urna, sit amet pellentesque turpis velit in sem.
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae; Etiam pulvinar congue dictum.
                  Nulla ultrices eleifend lacinia
                </div>
              }
              rightHeading="Lorem Ipsum"
              rightSubheading={
                <div>
                  <b>
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit.&nbsp;
                  </b>
                  <i>
                    Aliquam auctor massa eu quam venenatis tincidunt. Nunc a
                    mollis urna, sit amet placerat leo. Vivamus non rutrum urna.
                    Proin hendrerit erat in dolor hendrerit euismod.&nbsp;
                  </i>
                  <u>
                    Mauris elitnibh, congue vel augue sit amet, dignissim
                    consequat turpis.&nbsp;
                  </u>
                  Curabitur scelerisque, est tristique ultricies cursus, mi enim
                  suscipit urna, sit amet pellentesque turpis velit in sem.
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae; Etiam pulvinar congue dictum.
                  Nulla ultrices eleifend lacinia
                </div>
              }
              button={
                <Button variant="primary-outline" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              variant="white"
              leftHeading="Lorem Ipsum"
              leftSubheading={
                <div>
                  <b>
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit.&nbsp;
                  </b>
                  <i>
                    Aliquam auctor massa eu quam venenatis tincidunt. Nunc a
                    mollis urna, sit amet placerat leo. Vivamus non rutrum urna.
                    Proin hendrerit erat in dolor hendrerit euismod.&nbsp;
                  </i>
                  <u>
                    Mauris elitnibh, congue vel augue sit amet, dignissim
                    consequat turpis.&nbsp;
                  </u>
                  Curabitur scelerisque, est tristique ultricies cursus, mi enim
                  suscipit urna, sit amet pellentesque turpis velit in sem.
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae; Etiam pulvinar congue dictum.
                  Nulla ultrices eleifend lacinia
                </div>
              }
              overlineLabel={
                <Label leftIcon={light('circle-exclamation')}>
                  Lorem Ipsum
                </Label>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              variant="blue"
              leftHeading="Lorem Ipsum"
              leftSubheading={
                <div>
                  <b>
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit.&nbsp;
                  </b>
                  <i>
                    Aliquam auctor massa eu quam venenatis tincidunt. Nunc a
                    mollis urna, sit amet placerat leo. Vivamus non rutrum urna.
                    Proin hendrerit erat in dolor hendrerit euismod.&nbsp;
                  </i>
                  <u>
                    Mauris elitnibh, congue vel augue sit amet, dignissim
                    consequat turpis.&nbsp;
                  </u>
                  Curabitur scelerisque, est tristique ultricies cursus, mi enim
                  suscipit urna, sit amet pellentesque turpis velit in sem.
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae; Etiam pulvinar congue dictum.
                  Nulla ultrices eleifend lacinia
                </div>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 pl-10 col-12">
            <DefaultCard
              variant="blue-motif"
              leftHeading="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam auctor massa eu quam venenatis tincidunt. Nunc a mollis urna, sit amet placerat leo. Vivamus non rutrum urna. Proin hendrerit erat in dolor hendrerit euismod. Mauris elit nibh, congue vel augue sit amet, dignissim consequat turpis. Curabitur scelerisque, est tristique ultricies cursus, mi enim suscipit urna, sit amet pellentesque turpis velit in sem. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam pulvinar congue dictum. Nulla ultrices eleifend lacinia"
              leftSubheading={
                <div>
                  <b>
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit.&nbsp;
                  </b>
                  <i>
                    Aliquam auctor massa eu quam venenatis tincidunt. Nunc a
                    mollis urna, sit amet placerat leo. Vivamus non rutrum urna.
                    Proin hendrerit erat in dolor hendrerit euismod.&nbsp;
                  </i>
                  <u>
                    Mauris elitnibh, congue vel augue sit amet, dignissim
                    consequat turpis.&nbsp;
                  </u>
                  Curabitur scelerisque, est tristique ultricies cursus, mi enim
                  suscipit urna, sit amet pellentesque turpis velit in sem.
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae; Etiam pulvinar congue dictum.
                  Nulla ultrices eleifend lacinia
                </div>
              }
              button={
                <Button variant="primary-shadow" size="sm">
                  Proceed
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 px-0 col-12" style={{ maxWidth: '384px' }}>
            <DefaultCard
              variant="blue"
              leftHeading="HealthEquity"
              leftSubheading={'View balances, claims, eligible expenses &amp; more'}
              image={
                <div className={'mt-10'} style={{width: '30px', height: '100%'}}>
                  <img src={TulipIcon} alt={'tulip icon'} />
                </div>
              }
              button={
                <Button
                  variant="primary-shadow"
                  size="sm"
                  rightIcon={light('arrow-up-right-from-square')}
                >
                  Visit
                </Button>
              }
            />
          </Col>
          <Col className="mt-10 ms-lg-12 px-0 col-12" style={{ maxWidth: '384px' }}>
            <DefaultCard
              variant="blue-motif"
              leftHeading="Benefit Card Status"
              image={
                <>
                <div style={{marginTop: '-18px', marginLeft: '-24px', marginBottom: '-24px'}}>
                  <img src={DemoCard} alt={'demo card'} />
                </div>
                <div className='status-wrapper'>
                  <span>{'Ready'}</span>
                </div>
                </>
              }
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default DefaultCardDemo;
